import { increment } from 'vuex-easy-firestore';
import fb from '@/firebaseConfig';

export default {
  addCard(
    { dispatch, getters, rootState, state },
    { pageId, title = '', summary = '', order = undefined }
  ) {
    //throw an error if anythin is missing
    if (order !== undefined && isNaN(order)) {
      throw 'the order provided is not a number';
    }
    if (pageId == undefined) {
      throw 'no pageId was provided for the new note';
    }

    // get the note blocks to determine last item order and to update order later
    const page = state.pages[pageId];
    const pageCards = Object.values(page.noteCards).filter(n => !n.toDelete);

    const newOrder = order !== undefined ? order : pageCards.length;

    //get necessary Id's (generated for new Id and user ID for created by)
    const id = getters['dbRef'].doc().id;
    const userId = rootState.auth.currentUser.uid;

    //create the update object for the addition of the note
    const cardUpdate = {};
    cardUpdate[id] = {
      id,
      assignedTo: [],
      createdBy: userId,
      createdOn: fb.util.timestamp.now(),
      updatedOn: fb.util.timestamp.now(),
      order: newOrder,
      state: 0,
      summary,
      title
    };

    //update all the other notes that have a greater order than the one being added to be +1
    pageCards.forEach(card => {
      if (card.order > order) {
        cardUpdate[card.id] = {
          order: increment(1)
        };
      }
    });

    //update vuex and database with vuex-easy-firestore
    dispatch('patch', { id: pageId, noteCards: cardUpdate });
    dispatch('context/addToAuthorIfNecessary', {}, { root: true });
    dispatch('batchSync');
    return id;
  },
  removeCard({ dispatch, state }, { pageId, cardId }) {
    console.log('remove card', cardId);
    //get necessary Id's
    if (!cardId) {
      throw 'no NoteBlockId was provided for the note you want to remove';
    }
    if (!pageId) {
      throw 'no pageId was provided for the note you want to remove';
    }

    //find it's order and update all the ones with order greater than it

    const page = state.pages[pageId];
    const pageCards = Object.values(page.noteCards).filter(n => !n.toDelete);
    const currentCard = page.noteCards[cardId];

    const { order } = currentCard;
    const cardsUpdate = {};
    pageCards.forEach(card => {
      if (card.order > order) {
        cardsUpdate[card.id] = {
          order: increment(-1)
        };
      }
    });

    //delete the field that we no longer need
    cardsUpdate[cardId] = {};
    cardsUpdate[cardId].toDelete = true;

    //update the orders if the object length is not 0
    if (Object.keys(cardsUpdate).length !== 0) {
      dispatch('patch', { id: pageId, notesToDelete: true, noteCards: cardsUpdate });
      dispatch('context/addToAuthorIfNecessary', {}, { root: true });
    } else {
      console.log('no order needed updated');
    }
  },
  updateCardTitle({ commit, dispatch }, { pageId, cardId, title }) {
    //get necessary Id's
    if (title == undefined) {
      throw 'no title field was provided for the updated card title';
    }
    if (!cardId) {
      throw 'no cardId was provided for the card you want to update';
    }
    if (!pageId) {
      throw 'no pageId was provided for the card you want to update';
    }
    //commit('mutateCardTitle', { pageId, cardId, title });
    // return;
    //create the update object
    const noteCards = {};
    noteCards[cardId] = { title: title };

    //update vuex and database with vuex-easy-firestore
    dispatch('patch', { id: pageId, noteCards: noteCards });
    dispatch('context/addToAuthorIfNecessary', {}, { root: true });
  },
  setCardState({ dispatch }, { pageId, cardId, newState }) {
    if (newState == undefined) {
      throw 'no state field was provided for the updated card state';
    }
    if (!cardId) {
      throw 'no cardId was provided for the card you want to update';
    }
    if (!pageId) {
      throw 'no pageId was provided for the card you want to update';
    }
    const cardUpdate = {};
    cardUpdate[cardId] = { state: newState };
    dispatch('patch', { id: pageId, noteCards: cardUpdate });
    dispatch('context/addToAuthorIfNecessary', {}, { root: true });
  },
  setCardSummary({ dispatch }, { pageId, cardId, summary }) {
    if (summary == undefined) {
      throw 'no state field was provided for the updated card state';
    }
    if (!cardId) {
      throw 'no cardId was provided for the card you want to update';
    }
    if (!pageId) {
      throw 'no pageId was provided for the card you want to update';
    }
    const cardUpdate = {};
    cardUpdate[cardId] = { summary };
    dispatch('patch', { id: pageId, noteCards: cardUpdate });
  },
  assignCardTo({ dispatch }, { pageId, cardId, userIds }) {
    //get necessary Id's
    if (userIds == undefined) {
      throw 'no userId field was provided for the updated noteblock';
    }
    if (!cardId) {
      throw 'no cardId was provided for the noteblock you want to update';
    }
    if (!pageId) {
      throw 'no pageId was provided for the noteblock you want to update';
    }

    //create the update object
    const update = {};
    update[cardId] = {
      assignedTo: userIds
    };

    //update vuex and database with vuex-easy-firestore
    dispatch('patch', { id: pageId, noteCards: update });
    dispatch('context/addToAuthorIfNecessary', { userIds }, { root: true });
  },
  moveCard({ dispatch, state, getters }, { fromPageId = toPageId, toPageId, cardId, order }) {
    if (cardId == undefined) {
      throw 'no cardId field was provided for the card to move';
    }
    if (toPageId == undefined) {
      throw 'no toPageId was provided for the noteblock you want to update';
    }
    console.log('move card ', order);
    const fromPage = state.pages[fromPageId];
    const fromPageCards = Object.values(fromPage.noteCards).filter(c => !c.toDelete);
    const movedCard = fromPage.noteCards[cardId];
    let fromCardUpdate = {};
    let fromNoteUpdate = {};
    let toNoteUpdate = {};
    const newOrder = order != undefined ? order : getters.cardsByPage[toPageId].length;
    if (fromPageId == toPageId) {
      //  moving within card
      if (newOrder == undefined) throw 'order is required to move card';
      fromCardUpdate[cardId] = { order };
      if (newOrder < movedCard.order) {
        console.log('moving up page');
        // we are moving card up the page
        const cardsToAdjust = fromPageCards.filter(
          n => n.order < movedCard.order && n.order >= newOrder
        );
        cardsToAdjust.forEach(n => {
          fromCardUpdate[n.id] = { order: increment(1) };
        });
      } else {
        console.log('moving down page');
        //  we are moving card down the page
        const cardsToAdjust = fromPageCards.filter(
          n => n.order > movedCard.order && n.order <= newOrder
        );
        cardsToAdjust.forEach(n => {
          fromCardUpdate[n.id] = { order: increment(-1) };
        });
      }
    } else {
      //  Update the from page
      fromCardUpdate[cardId] = { toDelete: true };
      fromPageCards.forEach(n => {
        if (n.order > movedCard.order) {
          fromCardUpdate[n.id] = { order: increment(-1) };
        }
      });

      //  Update the to page
      const toCardUpdate = {};
      toCardUpdate[cardId] = { ...movedCard, order: newOrder, toDelete: false };
      const toPage = state.pages[toPageId];
      const toPageCards = Object.values(toPage.noteCards).filter(c => !c.toDelete);
      toPageCards.forEach(n => {
        if (n.order > movedCard.order) {
          toCardUpdate[n.id] = { order: increment(1) };
        }
      });
      // move all the notes, too
      const pageNotes = Object.values(fromPage.pageNotes).filter(
        n => !n.toDelete && n.cardId == cardId
      );
      const pageNoteIds = pageNotes.map(n => n.id);
      const subNotes = Object.values(fromPage.pageNotes).filter(
        n => !n.toDelete && n.parentNoteId && pageNoteIds.includes(n.parentNoteId)
      );

      const notesToMove = { ...pageNotes, subNotes };
      notesToMove.forEach(n => {
        //dispatch('delete', `${toPageId}.pageNotes.${n.id}`);
        fromNoteUpdate[n.id] = { toDelete: true };
        toNoteUpdate[n.id] = { ...n, toDelete: false };
      });
      const toUpdate = { id: toPageId, noteCards: toCardUpdate };
      if (Object.keys(toNoteUpdate).length) {
        toUpdate.pageNotes = toNoteUpdate;
      }
      dispatch('patch', toUpdate);
    }
    const fromUpdate = { id: fromPageId, noteCards: fromCardUpdate };
    if (Object.keys(fromNoteUpdate).length) {
      fromUpdate.pageNotes = fromNoteUpdate;
    }
    dispatch('patch', fromUpdate);
    dispatch('context/addToAuthorIfNecessary', {}, { root: true });
  }
};
